import React from 'react';
import ReactDOM from 'react-dom';
import { getCheckoutEndpoint } from '../common/constants';
import { createCheckoutRequest } from '../common/apiRequest';
import { postData } from '../common/api';
import { MDiscountCodePopup } from '../app/components/MDiscountCodePopup';
import { MDiscountCode } from '../app/components/MDiscountCode';
import { logger } from '../common/logger';
import {
  getShop,
  isCartPage,
  isInaEss,
  isLovintan,
  isShopifyThemeEditor,
} from '../common/pageData';
import {
  setMrDiscountCode,
  removeMrDiscountCode,
  getMrDiscountCode,
  getDiscountCodeFromApps,
  removeMrFreegiftDiscountCode,
  getIsShopifyFunctionsEnabled,
  getShopifyMonkCodesMapping,
} from '../common/settings';
import { createEmebeddedContainerWrapper } from '../common/html';
import { goToDiscountedCheckout } from '../common/navigation';

import { getMerchantSpecificThemeFlags } from '../app/components/helpers/offer';
import { getDiscountCodeStyleFromTheme } from '../app/components/helpers/style';

async function checkout(
  discountCode,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
) {
  // Remove mrDiscountCode if action is remove
  if (discountCode.action && discountCode.action === 'remove') {
    removeMrDiscountCode();
    removeMrFreegiftDiscountCode();
  }

  let cartDiscountModule;
  if (
    cartPageDiscountConfig &&
    discountCode.action &&
    (discountCode.action === 'apply' || discountCode.action === 'remove')
  ) {
    // eslint-disable-next-line import/no-cycle
    cartDiscountModule = await import('../cartDiscount');
  }

  if (discountCode.action && discountCode.action === 'remove') {
    if (cartDiscountModule) {
      await cartDiscountModule.checkAndUpdateCartDiscount({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        discountCode,
      });
    }
    return null;
  }

  const { orderRequest: checkoutReq } = await createCheckoutRequest(
    'cart',
    null,
    false,
    discountCode,
  );
  const response = await postData(getCheckoutEndpoint(), checkoutReq);
  if (!response) {
    return null;
  }
  if (discountCode.action && discountCode.action === 'apply') {
    if (response.discountCode.isValid) {
      if (response.discountCode.isFreeShippingCode) {
        return response;
      }
      // when shopify code can not combine with freegift rule code
      if (
        discountCode.checkForCombinationEnabled &&
        !response.discountCode.isProductCombinationEnabled
      ) {
        return response;
      }
      setMrDiscountCode(discountCode.code);
    }
    let cartResponse;

    if (cartDiscountModule) {
      cartResponse = await cartDiscountModule.checkAndUpdateCartDiscount({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        discountCode,
      });
    }
    if (!cartResponse) {
      return null;
    }
    if (getIsShopifyFunctionsEnabled()) {
      cartResponse.discountCode = response.discountCode;
      return cartResponse;
    }
    return response.discountCode;
  }

  if (response.discount_applicable === true) {
    goToDiscountedCheckout(response);
  }

  return response;
}

export function renderDiscountCodePopupInDiv(props) {
  logger.log('render discount code');
  const el = document.getElementById('mr-div-discount-code-12');
  if (el) {
    // const THEME = createTheme({
    //   typography: {
    //     fontFamily: props.theme && props.theme.font,
    //   },
    // });

    const updatedTheme = getMerchantSpecificThemeFlags({
      offerType: '',
      theme: props.theme,
      shopURL: getShop(),
    });

    ReactDOM.render(
      // <MuiThemeProvider theme={THEME}>
      <MDiscountCodePopup
        open={props.open}
        theme={updatedTheme}
        shopURL={getShop()}
        checkout={checkout}
        renderDiscountCodePopupInDiv={renderDiscountCodePopupInDiv}
        cartPageDiscountConfig={props.cartPageDiscountConfig}
        isDiscountCodeEnabled={props.isDiscountCodeEnabled}
        getDiscountCodeFromApps={getDiscountCodeFromApps}
        getMrDiscountCode={getMrDiscountCode}
        isSkipShopifyDiscountAPICall={false}
      />,
      el,
    );
  } else {
    const x = document.getElementsByTagName('BODY')[0];
    const elem = document.createElement('div');
    elem.setAttribute('id', 'mr-div-discount-code-12');
    x.appendChild(elem);
    renderDiscountCodePopupInDiv(props);
  }
}

export async function displayEmbeddedDiscountCode({
  show,
  offerType,
  theme,
  cartPageConfig,
  cartDrawerConfig,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  discountCodeValues,
  retryContainerCreation,
  mrCart,
}) {
  const containers = [];

  containers.push({
    selector: cartDrawerConfig.selector,
    position: cartDrawerConfig.position,
    containerID: `mr-div-embedded-discount-code-any-drawer`,
  });

  if (isCartPage()) {
    containers.push({
      selector: cartPageConfig.selector,
      position: cartPageConfig.position,
      containerID: `mr-div-embedded-discount-code-any-page`,
    });
  }

  if (!show) {
    for (let i = 0; i < containers.length; i += 1) {
      const { containerID } = containers[i];
      renderEmbeddedDiscountCodeInDiv({
        remove: true,
        containerID,
        theme: {},
      });
    }
    return;
  }

  const tasks = [];
  for (let i = 0; i < containers.length; i += 1) {
    const { containerID, selector, position } = containers[i];
    tasks.push(
      createContainerAndRender({
        offerType,
        theme,
        containerID,
        selector,
        position,
        retryContainerCreation,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        discountCodeValues,
        mrCart,
      }),
    );
  }

  await Promise.allSettled(tasks);
}

const createContainerAndRender = async ({
  offerType,
  theme,
  containerID,
  selector,
  position,
  retryContainerCreation,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  discountCodeValues,
  mrCart,
}) => {
  const existing = document.getElementById(containerID);
  if (existing) {
    renderEmbeddedDiscountCodeInDiv({
      offerType,
      theme,
      containerID,
      remove: false,
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
      discountCodeValues,
      mrCart,
    });
    return true;
  }

  const selectors = selector.split(',');
  const positions = position.split(',');
  let container;
  for (let i = 0; i < selectors.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    container = await createEmebeddedContainerWrapper({
      id: containerID,
      selector: selectors[i].trim(),
      position: positions[i],
      retryContainerCreation,
    });

    if (container) {
      break;
    }
  }

  if (container) {
    renderEmbeddedDiscountCodeInDiv({
      offerType,
      theme,
      containerID,
      remove: false,
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
      discountCodeValues,
      mrCart,
    });
    return true;
  }

  return false;
};

const renderEmbeddedDiscountCodeInDiv = ({
  offerType,
  theme,
  containerID,
  remove,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  discountCodeValues,
  mrCart,
}) => {
  if (remove && isShopifyThemeEditor()) {
    // for shopify theme editor leave the div as it is
    // TODO: handle case where the offer is displayed and then removed
    // so that dummy values can be displayed
    return;
  }

  const start = performance.now();
  const el = document.getElementById(containerID);
  const shopifyMonkCodesMapping = getShopifyMonkCodesMapping();

  const updatedTheme = getMerchantSpecificThemeFlags({
    offerType: offerType || '',
    theme,
    shopURL: getShop(),
  });
  const discountCodeStyles = getDiscountCodeStyleFromTheme(updatedTheme);

  if (el) {
    if (getShop() === 'hr-higgins.myshopify.com') {
      el.style.width = '60%';
    }

    if (
      [
        'tc-nutrition-canada.myshopify.com',
        'artizara-com.myshopify.com',
        'mashi-box.myshopify.com',
        'visivite.myshopify.com',
        'seevo-in.myshopify.com',
        'onelove-shop-590a.myshopify.com',
        'premiumcrafted.myshopify.com',
        'little-baby-grains.myshopify.com',
        'flaire-accessories.myshopify.com',
        'elinor-jewels.myshopify.com',
        'smashedgrapes.myshopify.com',
        'thequirkypagan.myshopify.com',
        'almanac-supply-company.myshopify.com',
        'barber-plug-supply-co.myshopify.com',
        'shopwindblown.myshopify.com',
        'sun-valley-b2c.myshopify.com',
        'hyperclean-store.myshopify.com',
        'gloveglu.myshopify.com',
        'jmofrance.myshopify.com',
        'bajio-prod.myshopify.com',
        'kabo-7925.myshopify.com',
      ].includes(getShop())
    ) {
      el.style.display = 'flex';
      el.style.justifyContent = 'flex-end';
    }

    if (getShop() === 'pinned-golf.myshopify.com') {
      el.style.display = 'flex';
      el.style.justifyContent = 'center';
    }

    if (
      (isInaEss() ||
        [
          'beardedbrothers.myshopify.com',
          'thelegalpaige.myshopify.com',
        ].includes(getShop())) &&
      containerID === 'mr-div-embedded-discount-code-any-page'
    ) {
      el.style.display = 'flex';
      el.style.justifyContent = 'flex-end';
    }

    if (getShop() === 'anzy-home.myshopify.com') {
      el.style.display = 'flex';
      el.style.justifyContent = 'center';
    }

    if (getShop() === 'inuacare-gl.myshopify.com') {
      el.style.width = '100%';
    }

    // hide the widget for this store
    if (getShop() === 'twiningsna.myshopify.com') {
      el.style.display = 'none';
    }

    ReactDOM.render(
      <div>
        {!remove && (
          <MDiscountCode
            offerType={offerType}
            onApply={checkout}
            discountCodeStyles={discountCodeStyles}
            isBordered={false}
            cartPageDiscountConfig={cartPageDiscountConfig}
            isDiscountCodeEnabled={isDiscountCodeEnabled}
            initialAppliedCode={discountCodeValues.initialAppliedCode}
            initialIsDisplayAppliedInfo={
              discountCodeValues.initialIsDisplayAppliedInfo
            }
            isAutoAppliedFreegiftDiscountCode={
              discountCodeValues.isAutoAppliedFreegiftDiscountCode
            }
            getDiscountCodeFromApps={getDiscountCodeFromApps}
            isSkipShopifyDiscountAPICall={isLovintan()}
            mrCart={mrCart}
            shopifyMonkCodesMapping={shopifyMonkCodesMapping}
          />
        )}
      </div>,
      el,
    );
  }

  logger.Debug(performance.now() - start, 'render time');
};
